import 'twin.macro';
import 'styled-components/macro';

import { useNotificationContext } from 'core/context/Notifications';
import { Notification } from 'play/atoms/notification/Notification';

export const NotificationsContainer = () => {
  const { notifications, closeNotification } = useNotificationContext();

  return (
    // bottom-[90px] is required for notes screen
    <div tw="flex flex-col items-center justify-end fixed left-0 right-0 bottom-[90px] z-overlay pointer-events-none pt-[20px] px-[20px]">
      {notifications.map(({ id, type, title, duration, message }) => (
        <Notification
          key={id}
          id={id}
          type={type}
          title={title}
          duration={duration}
          message={message}
          onClose={() => closeNotification(id)}
        />
      ))}
    </div>
  );
};
